import PropTypes from 'prop-types';
// icons
import { Icon, addCollection } from '@iconify/react';
// @mui
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import ArrowCircleDownRoundedIcon from '@mui/icons-material/ArrowCircleDownRounded';
import { Box } from '@mui/material';
// Bundled glyphs: the Solar bold-duotone set the sidebar and the dashboard
// tiles use. Registered once here so they render instantly and offline — a
// name that is not in this file falls back to the Iconify API at runtime, the
// way the eva:* icons across the app always have. Regenerate the JSON with
// the script noted in src/theme/icons/README.md when a new name is added.
import solar from '../theme/icons/solar.json';

addCollection(solar);

// Keep password and file-menu icons local to avoid a placeholder -> SVG update,
// which can collide with DOM rewrites performed by Chrome page translation.
const LOCAL_ICONS = {
  'eva:eye-fill': VisibilityRoundedIcon,
  'eva:eye-off-fill': VisibilityOffRoundedIcon,
  'eva:link-2-fill': LinkRoundedIcon,
  'eva:arrow-circle-down-fill': ArrowCircleDownRoundedIcon
};

// ----------------------------------------------------------------------

Iconify.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  sx: PropTypes.object
};

export default function Iconify({ icon, sx, ...other }) {
  const LocalIcon = LOCAL_ICONS[icon];

  if (LocalIcon) {
    return <Box component={LocalIcon} sx={{ ...sx }} {...other} />;
  }

  return <Box component={Icon} icon={icon} sx={{ ...sx }} {...other} />;
}
